import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const atlassianAdmin = defineConnector({
  identifier: "atlassianAdmin",
  name: "Atlassian Cloud Admin",
  tagLine: "Organization and user administration",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.atlassian\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Atlassian Cloud Admin API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open [Atlassian API token settings](https://id.atlassian.com/manage-profile/security/api-tokens) and create an API token for the admin account you want to use. Copy the token when it is shown, because you may not be able to view it again later.",
        },
      ],
    },
    {
      title: "Connect your Atlassian Cloud Admin account",
      items: [
        {
          kind: "markdown",
          content:
            "Enter your Atlassian Cloud Admin instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Atlassian Organization Id",
          placeholder: "9fa3d2b7-k9l3-4bq1-z3d8-7x1m0a9e2b76",
          required: true,
          target: { kind: "configuration", field: "organizationId" },
          helperText: "The organization ID of your Atlassian account",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder:
            "ATCTT3xFfGN0_a1B2-c3D4_E5F6-G7H8I9JKLMNOPQRSTUVWXYZ1234567890=DEADBEEF",
          helperText: "The API key for your Atlassian account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.atlassian.com/",
  },
});
